import * as React from 'react';
import React__default from 'react';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var _excluded = ["color", "size", "style"];
var Icon = (function (SvgComponent) {
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var _props$color = props.color,
        color = _props$color === void 0 ? 'currentColor' : _props$color,
        _props$size = props.size,
        size = _props$size === void 0 ? '1em' : _props$size,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        otherProps = objectWithoutPropertiesLoose(props, _excluded);

    return /*#__PURE__*/React__default.createElement(SvgComponent, _extends_1({
      ref: ref,
      fill: color,
      width: size,
      height: size,
      style: _extends_1({}, style)
    }, otherProps));
  });
});

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M229.973 725.333c33.28 0 56.32 11.52 70.827 34.987l-26.027 14.933c-12.373-16.213-23.04-21.76-42.666-21.76-36.267 0-53.334 23.894-53.334 74.24V851.2c0 44.8 18.774 68.267 54.187 68.267 20.907 0 34.987-6.4 46.507-20.907l25.173 15.36c-16.213 23.04-39.68 33.707-73.387 33.707-57.6 0-86.186-32.854-86.186-99.84v-17.494c0-71.253 27.306-104.96 84.906-104.96zm208.214 0c61.44 0 89.173 29.44 89.173 94.72v33.28c0 64.854-27.733 94.294-89.173 94.294-60.16 0-87.894-29.867-87.894-94.294v-33.28c0-64.426 27.734-94.72 87.894-94.72zm367.36 0c36.693 0 59.306 13.654 68.693 41.387 4.267 12.373 5.973 29.013 5.973 54.187v122.88h-33.706V823.893c0-20.48-1.707-32.853-5.12-43.093-6.827-17.493-20.054-26.453-39.68-26.453-33.707 0-47.36 23.04-47.36 78.933v110.507H720.64V823.893c0-49.92-12.8-69.546-44.373-69.546-34.134 0-47.36 22.613-47.36 80.64v108.8H595.2V729.6h26.027l2.56 23.893c12.373-19.626 29.44-28.16 56.32-28.16 30.72 0 50.773 11.094 61.44 34.987 12.8-24.32 32.426-34.987 64-34.987zm-366.934 28.16c-37.12 0-54.613 21.76-54.613 68.694V851.2c0 46.507 17.493 68.267 54.613 68.267 37.547 0 55.04-21.76 55.04-68.267v-29.013c0-46.934-17.493-68.694-55.04-68.694zm68.694-649.301c71.893 0 137.386 27.648 186.581 72.832 67.499-14.72 110.25-7.339 127.19 21.973 16.98 29.227 1.962 69.974-44.374 121.088A276.352 276.352 0 01507.307 656.3a274.901 274.901 0 01-186.88-73.088c-21.291 4.522-40.96 7.082-58.24 7.082-32.768 0-57.174-8.789-68.779-28.885-16.939-29.312-1.963-69.973 44.459-121.045a276.352 276.352 0 01269.397-336.214zm235.861 249.387c-46.55 42.965-108.459 87.466-177.621 127.402-66.646 38.486-137.216 70.699-199.211 90.027a235.648 235.648 0 00140.928 46.507 237.653 237.653 0 00235.904-263.936zM251.605 483.968c-25.898 33.067-28.16 52.01-24.661 58.07 5.29 9.215 27.221 12.927 62.89 7.85a277.59 277.59 0 01-38.229-65.92zm255.659-341.163a237.653 237.653 0 00-226.517 308.48c10.666 33.792 28.586 64.214 52.01 89.6 54.187-14.293 126.891-43.392 213.419-93.226 75.563-43.691 141.867-92.672 187.563-138.582a237.227 237.227 0 00-51.798-89.344 235.99 235.99 0 00-174.677-76.928zm280.363 75.52c-3.499-6.101-21.163-13.653-62.763-7.68a273.828 273.828 0 0138.101 65.707c25.899-33.024 28.16-51.968 24.662-58.027z"
});

function SvgDomain(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "domain_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    ref: svgRef
  }, props), _ref, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomain);

var ForwardIcon = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(ForwardRef, _extends_1({}, props, {
    ref: ref
  }));
});
var KuFoxIcons = Icon(ForwardIcon);
KuFoxIcons.displayName = 'DomainOutlined';

export default KuFoxIcons;
